import React, { useCallback } from "react";

import PropTypes from "prop-types";

import { toBasicCodeOptions } from "components/flowable/ClassificationCodes/helpers";
import CodeTemplate from "components/flowable/ClassificationCodes/internal/CodeTemplate";
import { useDictionary } from "hooks";


const SEOCode = ({
	seoMinimum,
	seoMaximum,
	limitToFourDigits,
	...rest
}) => {
	const dictionary = useDictionary("classificationCodes.seo");

	const toCodeOptions = useCallback(
		response => toBasicCodeOptions(response, limitToFourDigits),
		[ limitToFourDigits ]
	);

	return (
		<CodeTemplate
			codeType="seo"
			toCodeOptions={toCodeOptions}
			dictionary={dictionary}
			maximumNumberOfCodes={seoMaximum}
			minimumNumberOfCodes={seoMinimum}
			{...rest}
		/>
	);
};

SEOCode.defaultProps = {
	seoMinimum: 1,
	seoMaximum: 6,
	includePercentage: true,
	limitToFourDigits: false,
};

SEOCode.propTypes = {
	seoMinimum: PropTypes.number,
	seoMaximum: PropTypes.number,
	includePercentage: PropTypes.bool,
	limitToFourDigits: PropTypes.bool,
	value: PropTypes.any,
	label: PropTypes.string,
	isRequired: PropTypes.bool,
	onChange: PropTypes.func.isRequired,
	enabled: PropTypes.bool.isRequired,
};

export default SEOCode;
